import axios from "axios";
import {url_active_chains, url_chain, url_chain_depend, url_chain_status, url_chains} from "../url";

export default function DB_Chain(token) {
    const formData = new FormData;
    formData.append('token', token);

    const appendToken = (data) => {
        const fd = new FormData;
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }


    const getChains = () => {
        return axios.post(url_chains, formData)
    }

    const getActiveChains = () => {
        return axios.post(url_active_chains, formData)
    }

    const getChain = (id) => {
        return axios.post(url_chain + id, formData)
    }


    const createChain = (data) => {
        return axios.post(url_chain, appendToken(data))
    }


    const updateChain = (data) => {
        return axios.put(url_chain, appendToken(data))
    }


    const statusChain = (data) => {
        return axios.post(url_chain_status, appendToken(data))
    }

    const dependChain = (id) => {
        return new Promise(resolve => {
            axios.get(url_chain_depend + id)
                .then(res => {
                    if (res.status == 200) {
                        resolve(false)
                    } else {
                        resolve(true)
                    }
                })
        })
    }


    return {
        getChains,
        getActiveChains,
        getChain,
        createChain,
        updateChain,
        statusChain,
        dependChain,
    }
}
